import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  vote(event: Event) {
    event.preventDefault()
    
    const form = (event.target as HTMLElement).closest('form')
    if (!form) return
    
    const button = form.querySelector('button[type="submit"]')
    if (!button) return
    
    // Add loading state
    form.classList.add('loading')
    button.setAttribute('disabled', 'true')
    
    // Submit the form
    form.requestSubmit()
    
    // Listen for turbo:frame-load to remove loading state
    document.addEventListener('turbo:frame-load', () => {
      form.classList.remove('loading')
      button.removeAttribute('disabled')
    }, { once: true })
  }
}
